
    import {
      withCompInfo,
      createComponentMapperModel,
    } from '@wix/editor-elements-integrations';

    const props = withCompInfo<any, any>()(
      ['compData', 'compStylableClass'],
      ({ compData, compStylableClass }) => {
        return {
          ...{"size":24,"colors":[{"value":"white","label":"color-1","disabled":false,"isDefault":false,"unavailable":false},{"value":"#f7a502","label":"color-23","disabled":false,"isDefault":false,"unavailable":false},{"value":"#ed24d9","label":"color-8","disabled":false,"isDefault":false,"unavailable":false},{"value":"black","label":"color-5","disabled":false,"isDefault":false,"unavailable":false}]},
          ...compData,
          className: compStylableClass
        };
      },
    );

    export default createComponentMapperModel({
      props,
    });
  